export default /* css */ `
.ripple-container {
  margin-top: 100px;
  align-items: center;
  border-radius: 24px;
  display: flex;
  height: 64px;
  justify-content: center;
  outline: 1px solid hsl(var(--ui-sys-color-outline));
  padding: 16px;
  position: relative;
  width: 64px;
  box-sizing: content-box;
}
`
